import request from '@/utils/request'

export function getClockInStatus() {
  return request({
    url: '/api/TutorComm/GetClockInStatus',
    method: 'post'
  })
}

export function registration() {
  return request({
    url: '/api/tutorcomm/Registration',
    method: 'post'
  })
}

export function showContract() {
  return request({
    url: '/api/tutorcomm/ShowContract',
    method: 'post'
  })
}

/** SignalR 关闭时 HTTP 轮询兜底：课程消息 */
export function getTutorClassMsgList() {
  return request({
    url: '/api/tutorcomm/TutorClassMsgList',
    method: 'post'
  })
}

/** SignalR 关闭时 HTTP 轮询兜底：系统消息 */
export function getTutorSysMsg() {
  return request({
    url: '/api/tutorcomm/TutorSysMsg',
    method: 'post'
  })
}

/** 课程通知 — 拒绝（Vue2 noticeSendRefuse） */
export function noticeSendRefuse(mid, reason) {
  return request({
    url: '/api/tutorcomm/NoticeSendRefuse',
    method: 'post',
    data: { mid, reason }
  })
}

/** 课程通知 — 已读接受（Vue2 readClassMsg） */
export function readClassMsg(Mid) {
  return request({
    url: '/api/tutorcomm/ReadClassMsg',
    method: 'post',
    data: { Mid }
  })
}

/** 系统消息 — 已读（Vue2 readSysMsg） */
export function readSysMsg(Mid) {
  return request({
    url: '/api/tutorcomm/ReadSysMsg',
    method: 'post',
    data: { Mid }
  })
}

/** 课程出勤确认操作（Vue2 absentNoticeOperate） */
export function absentNoticeOperate(data) {
  return request({
    url: '/api/TutorComm/AbsentNoticeOperate',
    method: 'post',
    data
  })
}
